<template>
  <div>
    <criterion-index
      :formSearch="formSearch"
      :enableExport="false"
      :columns="columns"
      :title="$t('menu.program_criterion_list')"
      :serviceName="serviceName"
    />
  </div>
</template>

<script>
import CriterionIndex from "./CriterionIndex";
import { ProgramCriterionCategoriesService } from "../../../services/programCriterionCategories.service";

export default {
  name: "Index",
  data() {
    return {
      serviceName: "criteria",
      formSearch: [
        {
          label: this.$t("program_criterion.name"),
          name: "name__~",
          value: "",
          type: "input"
        },
        {
          label: this.$t("program_criterion.category_name"),
          name: "criterion_category_id",
          value: "",
          type: "select",
          options: []
        }
      ],
      columns: {
        id: this.$t("program_criterion.id"),
        name: this.$t("program_criterion.name"),
        description: this.$t("program_criterion.description"),
        criterion_category_name: this.$t("program_criterion.category_name"),
        created_at: this.$t("program_criterion.created_at"),
        updated_at: this.$t("program_criterion.updated_at")
      }
    };
  },
  components: { CriterionIndex },
  methods: {
    async getCriteriaCategories() {
      const response = await new ProgramCriterionCategoriesService().getList({
        limit: 1000
      });
      this.formSearch[1].options = response.data || [];
      return response.data;
    }
  },
  mounted() {
    this.getCriteriaCategories();
  }
};
</script>
